import { sortBy } from 'lodash';
import moment from 'moment';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/**
 * Returns the list of messages from a chat session, sorted by postedOn timestamp
 * @param {Number} chatSessionId Chat session ID
 * @returns array
 */

export function useChatSessionMessages(chatSessionId) {
    const selectMessages = useMemo(() => (state) => state.chat.indexed[chatSessionId]?.messages, [chatSessionId]),
        messages = useSelector(selectMessages);

    return useMemo(() => {
        let result = messages ?? [];

        result = sortBy(messages, (message) => -1 * moment(message.postedOn).valueOf());

        return result;
    }, [messages]);
}
